import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

export default function IconCollapseAll(props: SvgIconProps) {
  return (
    <SVGIcon xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" {...props}>
      <path d="M5 15L9 11L13 15" stroke="currentColor" strokeWidth={props.strokeWidth ?? 1.6} />
      <path d="M5 3L9 7L13 3" stroke="currentColor" strokeWidth={props.strokeWidth ?? 1.6} />
    </SVGIcon>
  );
}
